import { ValidationRule } from './types';
import isRequiredRule from './isRequiredRule';

export default function getInputRules(rules: ValidationRule[], isRequired: boolean): ValidationRule[] {
    if (isRequired) {
        return [isRequiredRule, ...rules];
    }
    return rules;
}
